/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.BasicViewer";
        const DEFAULT_HEIGHT = "80vh";
        const FULLSCREEN_HEIGHT = "90vh";
        class BasicViewerWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("BasicViewerWidgetTypeClass.createInstance()");
                    return new BasicViewerInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("BasicViewerWidgetTypeClass._storeHtml()");
                    BasicViewerInstanceClass.HtmlData = htmlData;
                    if (BasicViewerInstanceClass.FullscreenHtml != null) {
                        this._presentInstances();
                    }
                };
                this._storeFullscreenHtml = (htmlData) => {
                    this._log.info("BasicViewerWidgetTypeClass._storeFullscreenHtml()");
                    BasicViewerInstanceClass.FullscreenHtml = htmlData;
                    if (BasicViewerInstanceClass.HtmlData != null) {
                        this._presentInstances();
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("BasicViewerWidgetTypeClass::constructor");
                if (BasicViewerInstanceClass.HtmlData != null && BasicViewerInstanceClass.FullscreenHtml != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    if (BasicViewerInstanceClass.HtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/BasicViewer/basic-viewer.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                    if (BasicViewerInstanceClass.FullscreenHtml == null) {
                        core.Loader.getVersionedHTML('widgets/BasicViewer/basic-viewer-fullscreen.html', this._storeFullscreenHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
            }
        }
        Widgets.BasicViewerWidgetTypeClass = BasicViewerWidgetTypeClass;
        class BasicViewerInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._outerDiv = null;
                this._mainPanel = null;
                this._contentPanel = null;
                this._viewerContent = null;
                this._docHolder = null;
                this._eformHolder = null;
                this._height = null;
                this._currentDocId = null;
                this._currentDoc = null;
                this._currentContentType = null;
                this._currentFileType = null;
                this._docTitle = null;
                this._loader = null;
                this._pdfViewer = null;
                this._eformViewer = null;
                this._suppressDocTitle = false;
                this._reactToSlots = [];
                this._lastReactedSlots = [];
                this._cloakIfEmpty = false;
                this._enableDocInfo = true;
                this._enableDownload = false;
                this._enablePrint = false;
                this._enableActions = true;
                this._enableFullscreen = true;
                this._iframeHolder = null;
                this._downloadButton = null;
                this._printButton = null;
                this._infoButton = null;
                this._actionsButton = null;
                this._fullscreenButton = null;
                this._resizeObserver = null;
                this._currentContentHeight = null;
                this._currentContentWidth = null;
                this._clearTriggers = null;
                this._refreshTriggers = null;
                this.presentInstance = () => {
                    var _a;
                    this._log.info("BasicViewerInstanceClass.presentInstance()");
                    this._container.innerHTML = BasicViewerInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._mainPanel = this._container.querySelector('#basicViewerWidget');
                    this._contentPanel = this._mainPanel.querySelector('#collapsePanel');
                    this._viewerContent = this._contentPanel.querySelector('#basicViewerWidgetContent');
                    this._docHolder = this._contentPanel.querySelector('#documentHolder');
                    this._eformHolder = this._contentPanel.querySelector('#eformHolder');
                    this._iframeHolder = this._contentPanel.querySelector('#iframeHolder');
                    this._docTitle = this._contentPanel.querySelector('#documentTitle');
                    let progressBarContainer = this._contentPanel.querySelector('#page-progress-container');
                    this._loader = this._contentPanel.querySelector('#documentLoader');
                    this._downloadButton = this._mainPanel.querySelector('#downloadDocumentButton');
                    this._printButton = this._mainPanel.querySelector('#printDocumentButton');
                    this._infoButton = this._mainPanel.querySelector('#documentInfoButton');
                    this._actionsButton = this._mainPanel.querySelector('#documentActionsButton');
                    this._fullscreenButton = this._mainPanel.querySelector('#fullscreenViewButton');
                    this._core.Helper.prepareWptLoader(this._loader, 'wpt-font wpt-font-icon_Doc');
                    (_a = this._resizeObserver) === null || _a === void 0 ? void 0 : _a.observe(this._viewerContent);
                    this._widgets.setTitle(this._config, this._container.querySelector('#basicViewerWidgetTitle'), 'STR_WPT_DOCVIEWER');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    let config = this._config;
                    if (config.hasOwnProperty('Height')) {
                        this._height = config.Height;
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using default height: " + DEFAULT_HEIGHT);
                        }
                        this._height = DEFAULT_HEIGHT;
                    }
                    this._contentPanel.style.height = this._height;
                    // reset the height of the viewer after reexpanding
                    let instance = this;
                    $(this._contentPanel).on('shown.bs.collapse', function () {
                        instance._contentPanel.style.height = instance._height;
                    });
                    if (config.hasOwnProperty("SuppressDocTitle"))
                        this._suppressDocTitle = config.SuppressDocTitle;
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        let launchButton = this._container.querySelector('#launchDetailButton');
                        launchButton.addEventListener('click', this._launchDetailView);
                        this._core.Functions.showElement(launchButton);
                    }
                    // Exception lists and overrides should be zeroed if not defined
                    if (config.hasOwnProperty("RespondToSlots") && (config.RespondToSlots != null))
                        this._reactToSlots = config.RespondToSlots;
                    else
                        this._reactToSlots = [];
                    if (config.hasOwnProperty("RespondToPrimaryDoc") && config.RespondToPrimaryDoc)
                        this._reactToSlots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                    if (config.hasOwnProperty("RespondToRelatedDoc") && config.RespondToRelatedDoc)
                        this._reactToSlots.push(WPTNamespace.Utilities.RELATED_SLOT_KEY);
                    // Emergency default
                    if (this._reactToSlots.length == 0)
                        this._reactToSlots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                    if (config.hasOwnProperty("CloakIfEmpty") && config.CloakIfEmpty != null)
                        this._cloakIfEmpty = config.CloakIfEmpty;
                    if (config.hasOwnProperty("ShowDocumentInfoButton") && config.ShowDocumentInfoButton != null)
                        this._enableDocInfo = config.ShowDocumentInfoButton;
                    if (config.hasOwnProperty("ShowActionsButton") && config.ShowActionsButton != null)
                        this._enableActions = config.ShowActionsButton;
                    if (config.hasOwnProperty("ShowDownloadButton") && config.ShowDownloadButton != null && config.ShowDownloadButton
                        && WPTNamespace.DocActions.DOWNLOAD in this._core.DocumentActions.Actions)
                        this._enableDownload = true;
                    if (config.hasOwnProperty("ShowPrintButton") && config.ShowPrintButton != null && config.ShowPrintButton
                        && WPTNamespace.DocActions.PRINT in this._core.DocumentActions.Actions)
                        this._enablePrint = true;
                    if (config.hasOwnProperty('ShowFullscreenButton') && config.ShowFullscreenButton != null)
                        this._enableFullscreen = config.ShowFullscreenButton;
                    if (config.hasOwnProperty('ClearTriggers') && config.ClearTriggers)
                        this._clearTriggers = config.ClearTriggers;
                    else
                        this._clearTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._clearTriggers);
                    if (config.hasOwnProperty('RefreshTriggers') && config.RefreshTriggers)
                        this._refreshTriggers = config.RefreshTriggers;
                    else
                        this._refreshTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                    if (this._enableDocInfo)
                        this._infoButton.addEventListener('click', this._requestDocumentInfo);
                    else
                        this._core.Functions.hideElement(this._infoButton);
                    if (this._enableDownload)
                        this._downloadButton.addEventListener('click', this._downloadDocument);
                    else
                        this._core.Functions.hideElement(this._downloadButton);
                    if (this._enablePrint)
                        this._printButton.addEventListener('click', this._printDocument);
                    else
                        this._core.Functions.hideElement(this._printButton);
                    if (this._enableActions)
                        this._actionsButton.addEventListener('click', this._showActionsMenu);
                    else
                        this._core.Functions.hideElement(this._actionsButton);
                    if (this._enableFullscreen)
                        this._fullscreenButton.addEventListener('click', this._showFullscreen);
                    else
                        this._core.Functions.hideElement(this._fullscreenButton);
                    let eformConf = null;
                    if (config.hasOwnProperty('EFormConfig') && config.EFormConfig != null) {
                        eformConf = config.EFormConfig;
                    }
                    this._pdfViewer = new PdfJsViewer(this._core, this, this._docHolder, this._loader, progressBarContainer);
                    this._eformViewer = new EFormViewer(this._core, this, this._eformHolder, this._loader, eformConf);
                    if (!this._resizeObserver) {
                        this._viewerContentResized();
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this.displayDocumentById = (docid) => {
                    this._log.info("BasicViewerInstanceClass.displayDocumentById()");
                    this._currentDocId = docid;
                    this._clearErrors();
                    this._core.Loader.genericServiceCall('/Documents.svc/rest/GetDocument/' + docid, this._getDocumentResponse, this._documentError, this._documentFailed);
                };
                this.displayDocument = (doc) => {
                    this._log.info("BasicViewerInstanceClass.displayDocument()");
                    this._currentDoc = doc;
                    this._currentDocId = doc.ItemNum;
                    this._currentFileType = doc.FileType;
                    this._currentContentType = null;
                    this._docTitle.innerHTML = "";
                    if (this._suppressDocTitle)
                        this._core.Functions.hideElement(this._docTitle);
                    else {
                        this._docTitle.appendChild(document.createTextNode(doc.Name));
                        this._core.Functions.showElement(this._docTitle);
                    }
                    this._core.Functions.hideElement(this._iframeHolder);
                    this._core.Functions.hideElement(this._eformHolder);
                    this._eformViewer.clearView();
                    this._core.Functions.showElement(this._docHolder);
                    this._pdfViewer.clearView(false);
                    let url = '/OnBaseDocument.ashx?wmode=transparent&id=' + this._currentDocId;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at file type: " + doc.FileType);
                    }
                    switch (doc.FileType) {
                        case "Electronic Form":
                        case "Virtual Electronic Form":
                            this._core.Loader.genericServiceCallTextData(url, this._displayEFormTextDocument, this._eformError);
                            break;
                        case "Unity Form":
                            let conf = this._core.Config.getMainConfig();
                            if (conf.hasOwnProperty('UnityFormDisplayOption') && conf.UnityFormDisplayOption.length > 0) {
                                switch (conf.UnityFormDisplayOption.toUpperCase()) {
                                    case "DOCPOP":
                                        this._displayUnityFormDocumentInDocPop();
                                        break;
                                    case "WPT":
                                        this._core.Loader.genericServiceCallTextData(url, this._displayHtmlTextDocument, this._unityFormError);
                                        break;
                                    default:
                                        console.warn("unknown UnityFormDisplayOption: " + conf.UnityFormDisplayOption);
                                        let msg = this._core.Locale.getTranslation('STR_WPT_UNKNOWN_UNITYFORMOPTION_MSG') + conf.UnityFormDisplayOption;
                                        this.addError(msg);
                                        return;
                                }
                            }
                            else {
                                this._displayUnityFormDocumentInDocPop();
                            }
                            break;
                        case "HTML":
                            this._core.Loader.genericServiceCallTextData(url, this._displayHtmlTextDocument, this._rawDocError);
                            break;
                        default:
                            this._core.Loader.genericServiceCallRawData(url, this._displayRawDocument, this._rawDocError);
                            break;
                    }
                    this._showLoader();
                };
                this.clearViewer = () => {
                    this._log.info("BasicViewerInstanceClass.clearViewer()");
                    this._clearErrors();
                    this._docTitle.innerHTML = "";
                    this._core.Functions.hideElement(this._docTitle);
                    this._checkDocActions(true);
                    this._core.Functions.hideElement(this._iframeHolder);
                    this._core.Functions.hideElement(this._eformHolder);
                    this._eformViewer.clearView();
                    this._core.Functions.hideElement(this._docHolder);
                    this._pdfViewer.clearView(false);
                    if (this._cloakIfEmpty)
                        this._core.Functions.hideElement(this._outerDiv);
                };
                this.formSaved = (response) => {
                    this._log.info("BasicViewerInstanceClass.formSaved()");
                    if (response.Forms.length > 0) {
                        let form = response.Forms[0];
                        if (form.Itemnum !== null && form.Itemnum !== undefined) {
                            // Tell everyone what we've done
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.FORM_SUBMITTED);
                            navEvent.ActivationID = form.Itemnum;
                            navEvent.PrimaryContext = form;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                    }
                };
                this._showLoader = () => {
                    this._log.info("BasicViewerInstanceClass._showLoader()");
                    let height = this._viewerContent.offsetHeight;
                    let width = this._viewerContent.offsetWidth;
                    let minValue = Math.min(height, width);
                    let fontValue = minValue / 3; // HACK: based on style for loader
                    this._loader.style.fontSize = fontValue + "px";
                    this._core.Functions.showElement(this._loader);
                };
                this._checkDocActions = (disableAll = false) => {
                    var _a;
                    this._log.info("BasicViewerInstanceClass._checkDocActions()");
                    let allowedRequest = new WPTNamespace.DocActions.DocActionAllowedRequest();
                    if ((_a = this._currentDoc) === null || _a === void 0 ? void 0 : _a.DocType)
                        allowedRequest.DocumentType = this._currentDoc.DocType;
                    if (this._currentContentType)
                        allowedRequest.PropertyBag.push(["ContentType", this._currentContentType]);
                    if (this._currentFileType)
                        allowedRequest.PropertyBag.push(["FileType", this._currentFileType]);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("checking allowed with: " + allowedRequest.PropertyBag);
                    }
                    if (this._enableDownload) {
                        if (!disableAll && this._core.DocumentActions.Actions[WPTNamespace.DocActions.DOWNLOAD].actionAllowed(allowedRequest)) {
                            this._core.Functions.showElement(this._downloadButton);
                        }
                        else {
                            this._core.Functions.hideElement(this._downloadButton);
                        }
                    }
                    if (this._enablePrint) {
                        if (!disableAll && this._core.DocumentActions.Actions[WPTNamespace.DocActions.PRINT].actionAllowed(allowedRequest)) {
                            this._core.Functions.showElement(this._printButton);
                        }
                        else {
                            this._core.Functions.hideElement(this._printButton);
                        }
                    }
                };
                this._requestDocumentInfo = (event) => {
                    this._log.info("BasicViewerInstanceClass._requestDocumentInfo()");
                    if (this._currentDoc) {
                        let config = this._config;
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DISPLAY_DOC_PROPS);
                        navEvent.ActivationID = this._currentDocId;
                        navEvent.PrimaryContext = this._currentDoc;
                        navEvent.Decloak = true;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._getDocumentResponse = (data) => {
                    this._log.info("BasicViewerInstanceClass._getDocumentResponse()");
                    if (data.hasOwnProperty('Documents') && data.Documents && data.Documents.length > 0) {
                        this.displayDocument(data.Documents[0]);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no documents");
                        }
                        let msg = this._core.Locale.getTranslation("STR_WPT_DOC_FAILED_MSG") + ": " + this._currentDocId;
                        this.addError(msg);
                    }
                };
                this._documentError = () => {
                    this._log.info("BasicViewerInstanceClass._documentError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_DOC_FAILED_MSG") + ": " + this._currentDocId;
                    this.addError(msg);
                };
                this._documentFailed = (data) => {
                    this._log.info("BasicViewerInstanceClass._documentFailed()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_DOC_FAILED_MSG") + ": " + this._currentDocId;
                    if (data.hasOwnProperty('Connection') && data.Connection.hasOwnProperty('Message') && data.Connection.Message.length > 0) {
                        msg += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + data.Connection.Message;
                    }
                    this.addError(msg);
                };
                this._displayRawDocument = (rawData) => {
                    this._log.info("BasicViewerInstanceClass._displayRawDocument()");
                    if (this._cloakIfEmpty)
                        this._core.Functions.showElement(this._outerDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + rawData.ContentType);
                    }
                    this._currentContentType = rawData.ContentType;
                    this._checkDocActions();
                    switch (rawData.ContentType) {
                        case 'application/pdf':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("pdf data raw: " + rawData.ContentRaw);
                            }
                            this._displayPDFDocument(rawData.ContentRaw);
                            break;
                        default:
                            console.error("viewing of file type '" + this._currentDoc.FileType + "' with content type '" + rawData.ContentType + "' not supported");
                            let msg = this._core.Locale.getTranslation("STR_WPT_DOC_FAILED_MSG") + ": " + this._currentDocId;
                            this.addError(msg);
                            break;
                    }
                };
                this._rawDocError = () => {
                    this._log.info("BasicViewerInstanceClass._rawDocError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_DOC_FAILED_MSG") + ": " + this._currentDocId;
                    this.addError(msg);
                };
                this._displayEFormTextDocument = (textData) => {
                    this._log.info("BasicViewerInstanceClass._displayEFormTextDocument()");
                    if (this._cloakIfEmpty)
                        this._core.Functions.showElement(this._outerDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + textData.ContentType);
                    }
                    this._currentContentType = textData.ContentType;
                    this._checkDocActions();
                    switch (textData.ContentType) {
                        case 'text/html':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("html text data: " + textData.ContentText.substring(0, 500));
                            }
                            this._displayEFormDocument(textData.ContentText);
                            break;
                        default:
                            console.error("viewing of file type '" + this._currentDoc.FileType + "' with content type '" + textData.ContentType + "' not supported");
                            let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentDocId;
                            this.addError(msg);
                            break;
                    }
                };
                this._eformError = () => {
                    this._log.info("BasicViewerInstanceClass._eformError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_FORM_FAILED_MSG") + ": " + this._currentDocId;
                    this.addError(msg);
                };
                this._displayEFormDocument = (formData) => {
                    this._log.info("BasicViewerInstanceClass._displayEFormDocument()");
                    if (this._cloakIfEmpty)
                        this._core.Functions.showElement(this._outerDiv);
                    this._core.Functions.hideElement(this._docHolder);
                    this._core.Functions.hideElement(this._iframeHolder);
                    this._pdfViewer.clearView(false);
                    this._core.Functions.showElement(this._eformHolder);
                    this._eformViewer.renderEForm(this._currentDocId, formData);
                };
                this._displayHtmlTextDocument = (textData) => {
                    this._log.info("BasicViewerInstanceClass._displayHtmlTextDocument()");
                    if (this._cloakIfEmpty)
                        this._core.Functions.showElement(this._outerDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at content type: " + textData.ContentType);
                    }
                    this._currentContentType = textData.ContentType;
                    switch (textData.ContentType) {
                        case 'text/html':
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("html text data: " + textData.ContentText.substring(0, 500));
                            }
                            this._displayHtmlDocument(textData.ContentText);
                            break;
                        default:
                            console.error("viewing of file type '" + this._currentDoc.FileType + "' with content type '" + textData.ContentType + "' not supported");
                            let msg = this._core.Locale.getTranslation("STR_WPT_DOC_FAILED_MSG") + ": " + this._currentDocId;
                            this.addError(msg);
                            break;
                    }
                };
                this._unityFormError = () => {
                    this._log.info("BasicViewerInstanceClass._unityFormError()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_UNITYFORM_FAILED_MSG") + ": " + this._currentDoc.DocType.Name;
                    this.addError(msg);
                };
                this._unityFormFailed = (formData) => {
                    this._log.info("BasicViewerInstanceClass._unityFormFailed()");
                    let msg = this._core.Locale.getTranslation("STR_WPT_UNITYFORM_FAILED_MSG") + ": " + this._currentDoc.DocType.Name;
                    if (formData.hasOwnProperty('Connection') && formData.Connection.hasOwnProperty('Message') && formData.Connection.Message.length > 0) {
                        msg += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + formData.Connection.Message;
                    }
                    this.addError(msg);
                };
                this._displayUnityFormDocumentInDocPop = () => {
                    this._log.info("BasicViewerInstanceClass._displayUnityFormDocumentInDocPop()");
                    let safeName = this._core.Functions.safeEncodeURIComponent(this._currentDoc.DocType.Name);
                    this._core.Loader.genericServiceCall('/Forms.svc/rest/GetUnityFormTemplateByName/' + safeName, this._displayUnityFormInDocPop, this._unityFormError, this._unityFormFailed, false);
                };
                this._displayHtmlDocument = (htmlData) => {
                    this._log.info("BasicViewerInstanceClass._displayHtmlDocument()");
                    if (this._cloakIfEmpty)
                        this._core.Functions.showElement(this._outerDiv);
                    this._checkDocActions();
                    this._core.Functions.hideElement(this._eformHolder);
                    this._core.Functions.hideElement(this._docHolder);
                    this._eformViewer.clearView();
                    this._pdfViewer.clearView(false);
                    this._core.Functions.showElement(this._iframeHolder);
                    this._iframeHolder.src = "";
                    this._iframeHolder.srcdoc = htmlData;
                    this._core.Functions.hideElement(this._loader);
                };
                this._displayUnityFormInDocPop = (formData) => {
                    this._log.info("BasicViewerInstanceClass._displayUnityFormInDocPop()");
                    this._checkDocActions();
                    if (formData.Forms != null && formData.Forms.length > 0) {
                        this._core.Functions.hideElement(this._eformHolder);
                        this._core.Functions.hideElement(this._docHolder);
                        this._eformViewer.clearView();
                        this._pdfViewer.clearView(false);
                        this._core.Functions.showElement(this._iframeHolder);
                        let form = formData.Forms[0];
                        this._iframeHolder.removeAttribute("srcdoc");
                        this._iframeHolder.src = form.DocPopUrl + "?docid=" + this._currentDocId;
                        this._core.Functions.hideElement(this._loader);
                    }
                    else {
                        console.error("no unity form data");
                        let msg = this._core.Locale.getTranslation("STR_WPT_UNITYFORM_FAILED_MSG") + ": " + this._currentDoc.DocType.Name;
                        this.addError(msg);
                    }
                };
                this._displayPDFDocument = (pdfData) => {
                    this._log.info("BasicViewerInstanceClass._displayPDFDocument()");
                    if (this._cloakIfEmpty)
                        this._core.Functions.showElement(this._outerDiv);
                    this._core.Functions.hideElement(this._eformHolder);
                    this._core.Functions.hideElement(this._iframeHolder);
                    this._eformViewer.clearView();
                    this._core.Functions.showElement(this._docHolder);
                    this._pdfViewer.clearView(true);
                    this._pdfViewer.renderPDF(pdfData);
                };
                this._viewerContentResized = () => {
                    this._log.info("BasicViewerInstanceClass._viewerContentResized()");
                    let sizeActuallyChanged = false;
                    let rerenderingNecessary = false;
                    if (this._currentContentHeight != this._viewerContent.offsetHeight) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("changing content height from " + this._currentContentHeight + " to " + this._viewerContent.offsetHeight);
                        }
                        this._currentContentHeight = this._viewerContent.offsetHeight;
                        sizeActuallyChanged = true;
                    }
                    if (this._currentContentWidth != this._viewerContent.offsetWidth) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("changing content width from " + this._currentContentWidth + " to " + this._viewerContent.offsetWidth);
                        }
                        this._currentContentWidth = this._viewerContent.offsetWidth;
                        sizeActuallyChanged = true;
                        if (this._currentContentWidth > 0) {
                            rerenderingNecessary = true;
                        }
                    }
                    this._eformHolder.style.height = this._viewerContent.offsetHeight + "px";
                    if (this._viewerContent.offsetHeight > 1) {
                        this._iframeHolder.style.height = (this._viewerContent.offsetHeight - 1) + "px";
                    }
                    if (rerenderingNecessary && this._currentContentType == 'application/pdf') {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("size actually changed, rerendering pages...");
                        }
                        this._pdfViewer.reRenderPages();
                    }
                };
                this._launchDetailView = (event) => {
                    this._log.info("BasicViewerInstanceClass._launchDetailView()");
                    let config = this._config;
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout && this._currentDoc) {
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(null, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                        navEvent.ActivationID = this._currentDocId;
                        navEvent.PrimaryContext = this._currentDoc;
                        navEvent.Layout = config.LaunchLayout;
                        if (config.hasOwnProperty("LaunchUsingSlots") && config.LaunchUsingSlots && (config.LaunchUsingSlots.length > 0))
                            navEvent.Slots.push(...config.LaunchUsingSlots);
                        else
                            navEvent.Slots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._showFullscreen = () => {
                    this._log.info("BasicViewerInstanceClass._showFullscreen()");
                    let modalSession = 'basic-viewer-fullscreen-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        modal.DIV.innerHTML = BasicViewerInstanceClass.FullscreenHtml;
                        let resetBorder = false;
                        let viewerParent = modal.DIV.querySelector('#basicViewerFullscreenViewer');
                        let fullscreeenTitle = modal.DIV.querySelector('#basicViewerFullscreenHeading');
                        let header = this._mainPanel.querySelector('.widget__header');
                        let footer = this._mainPanel.querySelector('.widget__footer');
                        let titleText = header.querySelector('.widget__header-titleText');
                        if (titleText) {
                            fullscreeenTitle.innerHTML = titleText.innerHTML;
                        }
                        else {
                            fullscreeenTitle.innerHTML = header.querySelector('.widget__header-title').innerHTML;
                        }
                        if (!this._mainPanel.classList.contains('widget--no-border')) {
                            resetBorder = true;
                            this._mainPanel.classList.add('widget--no-border');
                        }
                        header.classList.add(WPTNamespace.HIDDEN_CLASS);
                        footer.classList.add(WPTNamespace.HIDDEN_CLASS);
                        viewerParent.appendChild(this._mainPanel);
                        this._contentPanel.style.height = FULLSCREEN_HEIGHT;
                        this._mainPanel.style.margin = "0";
                        this._mainPanel.style.boxShadow = "none";
                        // reset eform window in order to get proper window messaging
                        this._eformViewer.resetEformWindow();
                        let instance = this;
                        modal.JQ.one('hide.bs.modal', function () {
                            instance._container.appendChild(instance._mainPanel);
                            instance._contentPanel.style.height = instance._height;
                            if (resetBorder)
                                instance._mainPanel.classList.remove('widget--no-border');
                            header.classList.remove(WPTNamespace.HIDDEN_CLASS);
                            footer.classList.remove(WPTNamespace.HIDDEN_CLASS);
                            instance._mainPanel.style.removeProperty('margin');
                            instance._mainPanel.style.removeProperty('box-shadow');
                            // reset eform window in order to get proper window messaging
                            instance._eformViewer.resetEformWindow();
                        });
                        this._core.showModal(modalSession);
                    }
                    else {
                        console.error("unable to show basic viewer fullscreen modal, modal placeholder is already used");
                    }
                };
                this._downloadDocument = () => {
                    this._log.info("BasicViewerInstanceClass._downloadDocument()");
                    let request = new WPTNamespace.DocActions.DocActionRequest(this._currentDocId);
                    request.Document = this._currentDoc;
                    request.DocumentType = this._currentDoc.DocType;
                    this._core.DocumentActions.execute(WPTNamespace.DocActions.DOWNLOAD, request);
                };
                this._printDocument = () => {
                    this._log.info("BasicViewerInstanceClass._printDocument()");
                    let request = new WPTNamespace.DocActions.DocActionRequest(this._currentDocId);
                    request.Document = this._currentDoc;
                    request.DocumentType = this._currentDoc.DocType;
                    this._core.DocumentActions.execute(WPTNamespace.DocActions.PRINT, request);
                };
                this._showActionsMenu = (event) => {
                    var _a;
                    this._log.info("BasicViewerInstanceClass._showActionsMenu()");
                    let actionRequest = new WPTNamespace.DocActions.DocActionRequest(this._currentDoc.ItemNum);
                    actionRequest.Document = this._currentDoc;
                    if (this._currentDoc.DocType)
                        actionRequest.DocumentType = this._currentDoc.DocType;
                    let allowedRequest = new WPTNamespace.DocActions.DocActionAllowedRequest();
                    if ((_a = this._currentDoc) === null || _a === void 0 ? void 0 : _a.DocType)
                        allowedRequest.DocumentType = this._currentDoc.DocType;
                    if (this._currentContentType)
                        allowedRequest.PropertyBag.push(["ContentType", this._currentContentType]);
                    if (this._currentFileType)
                        allowedRequest.PropertyBag.push(["FileType", this._currentFileType]);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("checking allowed with: " + allowedRequest.PropertyBag);
                    }
                    this._core.DocumentActions.displayActionMenu(actionRequest, allowedRequest);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("BasicViewerInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                if (window.ResizeObserver) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("browser supports ResizeObserver");
                    }
                    this._resizeObserver = new ResizeObserver(this._viewerContentResized);
                }
                else {
                    console.warn("browser doesn't support ResizeObserver");
                }
            }
            activate(context) {
                this._log.info("BasicViewerInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (slots.length > 0) {
                            // only remember slots we react to
                            this._lastReactedSlots = slots;
                            this.displayDocumentById(context.ActivationID);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (intersection.length > 0) {
                            this._lastReactedSlots = [];
                            this.clearViewer();
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DELETED:
                        if (this._currentDocId && (this._currentDocId == context.ActivationID))
                            this.clearViewer();
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_REVISED:
                        if (this._currentDocId && (this._currentDocId == context.ActivationID))
                            this.displayDocumentById(context.ActivationID);
                        break;
                    default:
                        if (this._refreshTriggers.length > 0) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at refresh triggers: " + JSON.stringify(this._refreshTriggers));
                            }
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._refreshTriggers.length; i++) {
                                let trigger = this._refreshTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    if (this._currentDocId) {
                                        // Refresh assumes the same slots are in use
                                        this.displayDocumentById(this._currentDocId);
                                    }
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        if (this._clearTriggers.length > 0) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at clear triggers: " + JSON.stringify(this._clearTriggers));
                            }
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._clearTriggers.length; i++) {
                                let trigger = this._clearTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this._lastReactedSlots = [];
                                    this.clearViewer();
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        break;
                }
            }
        }
        BasicViewerInstanceClass.HtmlData = null;
        BasicViewerInstanceClass.FullscreenHtml = null;
        Widgets.BasicViewerInstanceClass = BasicViewerInstanceClass;
        class EFormViewerBaseClass {
            constructor(core, widget, container, loader) {
                this._core = null;
                this._log = null;
                this._widget = null;
                this._container = null;
                this._loader = null;
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("EFormViewerBaseClass::constructor");
                this._widget = widget;
                this._container = container;
                this._loader = loader;
            }
            renderEForm(docId, formData) {
                this._log.info("EFormViewerBaseClass.renderEForm()");
                throw new TypeError("Must override method renderEForm(docId: number, formData: string): void");
            }
            clearView() {
                this._log.info("EFormViewerBaseClass.clearView()");
                throw new TypeError("Must override method clearView(): void");
            }
            resetEformWindow() {
                this._log.info("EFormViewerBaseClass.resetEformWindow()");
                throw new TypeError("Must override method resetEformWindow(): void");
            }
        }
        class EFormViewer extends EFormViewerBaseClass {
            constructor(core, widget, container, loader, config) {
                super(core, widget, container, loader);
                this._formHandler = null;
                this.renderEForm = (docId, formData) => {
                    this._log.info("EFormViewer.renderEForm()");
                    this._formHandler.showFormDocument(docId, formData);
                };
                this.clearView = () => {
                    this._log.info("EFormViewer.clearView()");
                    this._formHandler.clearView();
                };
                this.resetEformWindow = () => {
                    this._log.info("EFormViewer.resetEformWindow()");
                    this._formHandler.resetEformWindow();
                };
                this._hideLoader = () => {
                    this._log.info("EFormViewer._hideLoader()");
                    this._core.Functions.hideElement(this._loader);
                };
                this._showLoader = () => {
                    this._log.info("EFormViewer._showLoader()");
                    this._core.Functions.showElement(this._loader);
                };
                this._log.info("EFormViewer::constructor");
                this._formHandler = new Widgets.ComponentEFormHandler(core, container, widget, config, widget.formSaved, this._hideLoader, this._showLoader);
                this._formHandler.present();
            }
        }
        class PdfViewerBaseClass {
            constructor(core, widget, docHolder, loader, progressBarContainer) {
                this._core = null;
                this._log = null;
                this._widget = null;
                this._holder = null;
                this._loader = null;
                this._progressContainer = null;
                this._progress = null;
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("PdfViewerBaseClass::constructor");
                this._widget = widget;
                this._holder = docHolder;
                this._loader = loader;
                this._progressContainer = progressBarContainer;
                this._progress = progressBarContainer.querySelector('#page-progress-bar');
            }
            renderPDF(pdfData) {
                this._log.info("PdfViewerBaseClass.renderPDF()");
                throw new TypeError("Must override method renderPDF(pdfData: ArrayBuffer): void");
            }
            reRenderPages() {
                this._log.info("PdfViewerBaseClass.reRenderPages()");
                throw new TypeError("Must override method reRenderPages(): void");
            }
            clearView(showProgressBar) {
                this._log.info("PdfViewerBaseClass.clearView()");
                throw new TypeError("Must override method clearView(showProgressBar: boolean): void");
            }
        }
        class PdfJsViewer extends PdfViewerBaseClass {
            constructor(core, widget, docHolder, loader, progressBarContainer) {
                super(core, widget, docHolder, loader, progressBarContainer);
                this._pdfToView = null;
                this._firstRenderedPage = 0;
                this._lastRenderedPage = 0;
                this._renderedPages = 0;
                this._totalPages = 0;
                this._scale = null;
                this._blockSize = 5; // default block size
                this._firstBlock = this._blockSize; // initial first block
                this._lastBlock = 4 * this._blockSize; // initial last block
                this._currentPage = 1;
                this._defaultOffset = 87; // default offset
                this._renderingRunning = false;
                this._loadingNextRequired = true;
                this._loadingPrevRequired = false;
                this._requestCounter = 0;
                this._pages = [];
                this._scroller = null;
                this._firstRenderingDone = null;
                this._reRenderingRunning = null;
                this._reRenderAgain = null;
                this.renderPDF = (pdfData) => {
                    this._log.info("PdfJsViewer.renderPDF()");
                    this._scroller.addEventListener('scroll', this._scrolled);
                    this._firstRenderingDone = false;
                    this._reRenderingRunning = false;
                    this._reRenderAgain = false;
                    this._requestCounter = 0;
                    this._currentPage = 0;
                    this._totalPages = 1;
                    this._updatePageProgressBar();
                    let pdfjsLib = window.PDFJS;
                    pdfjsLib.disableWorker = true; // disable worker (was set by Scott, this can be a performance optimization option)
                    pdfjsLib.getDocument(pdfData).then(this._renderPages); // start the rendering...
                };
                this.reRenderPages = () => {
                    this._log.info("PdfJsViewer.reRenderPages()");
                    if (!this._firstRenderingDone)
                        return;
                    if (this._reRenderingRunning) {
                        this._reRenderAgain = true;
                        return;
                    }
                    this._scroller.removeEventListener('scroll', this._scrolled); // disable scrolling while changing content
                    this._reRenderingRunning = true; // start rendering
                    for (let num = this._firstRenderedPage; num <= this._lastRenderedPage; num++) {
                        this._requestCounter++; // adjust request counter
                        this._pdfToView.getPage(num).then(this._reRenderPage);
                    }
                    if (this._requestCounter == 0) {
                        this._scroller.addEventListener('scroll', this._scrolled); // reenable scrolling after content is changed
                        this._reRenderingRunning = false; // no more rendering running now
                        if (this._reRenderAgain) {
                            this._reRenderAgain = false;
                            this.reRenderPages();
                        }
                    }
                };
                this.clearView = (showProgressBar) => {
                    this._log.info("PdfJsViewer.clearView()");
                    this._scroller.removeEventListener('scroll', this._scrolled);
                    this._holder.innerHTML = "";
                    this._firstRenderingDone = false;
                    this._reRenderingRunning = false;
                    this._reRenderAgain = false;
                    if (showProgressBar) {
                        this._core.Functions.showElement(this._progressContainer);
                    }
                    else {
                        this._core.Functions.hideElement(this._progressContainer);
                    }
                };
                this._scrolled = () => {
                    this._log.info("PdfJsViewer._scrolled()");
                    let pageHeight = this._scroller.scrollHeight / this._renderedPages; // calculate page height (assumes equal pages)
                    let scrolledPages = Math.floor(this._scroller.scrollTop / pageHeight); // calculate scrolled pages
                    let calculatedPage = this._firstRenderedPage + scrolledPages; // calculate current page based on first rendered page and scrolled pages
                    if (calculatedPage != this._currentPage) {
                        // update current page and progress bar if page changed
                        this._currentPage = calculatedPage;
                        this._updatePageProgressBar();
                    }
                    if (this._currentPage <= this._firstBlock) {
                        // check if loading of previous pages is necessary
                        if (this._loadingPrevRequired && !this._renderingRunning) {
                            // not first page reached and no rendering running, load previous pages
                            this._renderPrevPages(this._blockSize);
                        }
                    }
                    else if (this._currentPage > this._lastBlock) {
                        // check if loading of next pages is necessary
                        if (this._loadingNextRequired && !this._renderingRunning) {
                            // not last page reached and no rendering running, load next pages
                            this._renderNextPages(this._blockSize);
                        }
                    }
                };
                this._renderPages = (pdfDoc) => {
                    this._log.info("PdfJsViewer._renderPages()");
                    this._pdfToView = pdfDoc;
                    this._totalPages = pdfDoc.numPages;
                    this._firstRenderedPage = 1;
                    this._lastRenderedPage = 0;
                    this._renderedPages = 0;
                    this._scale = 1 / 1.5; // default view scale
                    this._blockSize = 5; // default block size
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('ViewerScale') && appConfig.ViewerScale) {
                        this._scale = 1 / appConfig.ViewerScale;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using viewer scale: " + this._scale);
                        }
                    }
                    if (appConfig.hasOwnProperty('ViewerBlockSize') && appConfig.ViewerBlockSize != null) {
                        // set block size if configured
                        this._blockSize = appConfig.ViewerBlockSize;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using viewer block size: " + this._blockSize);
                        }
                    }
                    this._firstBlock = 0; // initial value for first block, is changed after adding first pages
                    this._lastBlock = 3 * this._blockSize; // initial value for last block, is changed after adding first pages
                    this._currentPage = 1;
                    this._renderingRunning = false;
                    this._loadingNextRequired = true;
                    this._loadingPrevRequired = false;
                    this._updatePageProgressBar();
                    this._renderNextPages(5 * this._blockSize); // render five times the block size initially
                    this._core.Functions.hideElement(this._loader);
                };
                this._updatePageProgressBar = () => {
                    this._log.info("PdfJsViewer._updatePageProgressBar()");
                    let percentage = (this._currentPage / this._totalPages) * 100; // calculate percentage based on pages
                    this._progress.style.width = percentage + "%"; // set width of progress bar
                };
                this._reRenderPage = (page) => {
                    this._log.info("PdfJsViewer._reRenderPage()");
                    // TODO: look at ways to use actual scrollbar width instead of guessed 17px (seems only possible after the whole rendering has been done)
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("reRenderPage - using offset width: " + this._scroller.offsetWidth);
                    }
                    let viewport = page.getViewport((this._scroller.offsetWidth - WPTNamespace.SCROLLBAR_WIDTH) / page.getViewport(this._scale).width); // calculate viewport
                    let canvas = document.createElement('canvas');
                    let ctx = canvas.getContext('2d');
                    let renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    canvas.style.height = (viewport.height * this._scale) + "px";
                    canvas.style.width = (viewport.width * this._scale) + "px";
                    canvas.id = "page-" + page.pageNumber;
                    let pdf = this;
                    page.render(renderContext).then(function () {
                        pdf._requestCounter--; // addjust request counter
                        let pageNumber = page.pageNumber;
                        page.cleanup(); // free memory/resources
                        pdf._reAppendPage(pageNumber, canvas);
                    });
                };
                this._reAppendPage = (num, canvas) => {
                    this._log.info("PdfJsViewer._reAppendPage()");
                    this._pages.push({ pagenumber: num, element: canvas }); // add canvas to pages array
                    if (this._requestCounter == 0) {
                        // all rendering requests have returned, do the real work now
                        this._pages.sort(function (a, b) { return a.pagenumber - b.pagenumber; }); // sort pages ascending by page numbers
                        let pageLength = this._pages.length;
                        this._holder.innerHTML = "";
                        for (let i = 0; i < pageLength; i++) {
                            let page = this._pages.shift(); // get page and remove from array
                            this._holder.appendChild(page.element); // append canvas to end
                        }
                        // get offsetTop of first canvas to correct calculation for scrolling
                        let firstCanvas = this._holder.querySelector('#page-' + this._firstRenderedPage);
                        if (firstCanvas) {
                            this._defaultOffset = firstCanvas.offsetTop;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("setting default offset: " + this._defaultOffset);
                            }
                        }
                        // adjust scrolling
                        let currentCanvas = this._holder.querySelector('#page-' + this._currentPage); // get canvas of current page
                        if (currentCanvas) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("current offset top: " + currentCanvas.offsetTop);
                            }
                            let calcOffsetTop = currentCanvas.offsetTop - this._defaultOffset + 10; // calculate corrected offsetTop of current page
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("after rerender: calculated offset top for current page " + this._currentPage + ": " + calcOffsetTop);
                            }
                            this._scroller.scrollTop = calcOffsetTop; // scroll to current page (again), after swapping pages
                        }
                        this._scroller.addEventListener('scroll', this._scrolled); // reenable scrolling after content is changed
                        this._reRenderingRunning = false; // no more rendering running now
                        if (this._reRenderAgain) {
                            this._reRenderAgain = false;
                            this.reRenderPages();
                        }
                    }
                };
                this._renderNextPages = (pageCount) => {
                    this._log.info("PdfJsViewer._renderNextPages()");
                    this._renderingRunning = true; // start rendering
                    let endPage = this._lastRenderedPage + pageCount; // calculate end page
                    if (this._totalPages < endPage) {
                        // last page reached
                        endPage = this._totalPages;
                        if (this._loadingNextRequired) {
                            // loading next was required before, but is no more
                            this._loadingNextRequired = false;
                        }
                    }
                    for (let num = this._lastRenderedPage + 1; num <= endPage; num++) {
                        this._requestCounter++; // adjust request counter
                        this._pdfToView.getPage(num).then(this._renderNextPage);
                    }
                    if (this._requestCounter == 0) {
                        // nothing to render, stop rendering
                        this._renderingRunning = false;
                    }
                };
                this._renderNextPage = (page) => {
                    this._log.info("PdfJsViewer._renderNextPage()");
                    // TODO: look at ways to use actual scrollbar width instead of guessed 17px (seems only possible after the whole rendering has been done)
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("renderNextPage - using offset width: " + this._scroller.offsetWidth);
                    }
                    let viewport = page.getViewport((this._scroller.offsetWidth - WPTNamespace.SCROLLBAR_WIDTH) / page.getViewport(this._scale).width); // calculate viewport
                    let canvas = document.createElement('canvas');
                    let ctx = canvas.getContext('2d');
                    let renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    canvas.style.height = (viewport.height * this._scale) + "px";
                    canvas.style.width = (viewport.width * this._scale) + "px";
                    canvas.id = "page-" + page.pageNumber;
                    let pdf = this;
                    page.render(renderContext).then(function () {
                        pdf._requestCounter--; // addjust request counter
                        let pageNumber = page.pageNumber;
                        page.cleanup(); // free memory/resources
                        pdf._appendPage(pageNumber, canvas);
                    });
                };
                this._appendPage = (num, canvas) => {
                    this._log.info("PdfJsViewer._appendPage()");
                    this._pages.push({ pagenumber: num, element: canvas }); // add canvas to pages array
                    if (this._requestCounter == 0) {
                        // all rendering requests have returned, do the real work now
                        this._pages.sort(function (a, b) { return a.pagenumber - b.pagenumber; }); // sort pages ascending by page numbers
                        let pageLength = this._pages.length;
                        for (let i = 0; i < pageLength; i++) {
                            if (this._holder.childNodes.length >= 5 * this._blockSize) {
                                // already "all" pages there, remove pages already "read" (or scrolled through)
                                this._firstRenderedPage++; // adjust first page
                                this._holder.removeChild(this._holder.firstChild); // remove first canvas
                                if (!this._loadingPrevRequired) {
                                    // loading previous was not required before, but is now
                                    this._loadingPrevRequired = true;
                                }
                            }
                            let page = this._pages.shift(); // get page and remove from array
                            this._holder.appendChild(page.element); // append canvas to end
                            this._lastRenderedPage++; // adjust last page
                            if (this._renderedPages < pageLength) {
                                this._renderedPages++; // addjust rendered pages
                            }
                            if (page.pagenumber == 1) {
                                // get offsetTop of first canvas to correct calculation for scrolling
                                let firstCanvas = this._holder.querySelector('#page-' + 1);
                                this._defaultOffset = firstCanvas.offsetTop;
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("setting default offset: " + this._defaultOffset);
                                }
                            }
                        }
                        this._firstBlock += this._blockSize; // adjust first block
                        this._lastBlock += this._blockSize; // adjust last block
                        // adjust scrolling
                        let currentCanvas = this._holder.querySelector('#page-' + this._currentPage); // get canvas of current page
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("current page offset top: " + currentCanvas.offsetTop);
                        }
                        let calcOffsetTop = currentCanvas.offsetTop - this._defaultOffset; // calculate corrected offsetTop of current page
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("calculated offset top: " + calcOffsetTop);
                        }
                        this._scroller.scrollTop = calcOffsetTop; // scroll to current page (again), after swapping pages
                        this._renderingRunning = false; // nore more rendering running now
                        this._firstRenderingDone = true;
                        this._updatePageProgressBar(); // adjust progress bar
                    }
                };
                this._renderPrevPages = (pageCount) => {
                    this._log.info("PdfJsViewer._renderPrevPages()");
                    this._renderingRunning = true; // start rendering
                    let startPage = this._firstRenderedPage - pageCount; // caluclate start page
                    if (startPage < 1) {
                        // first page reached
                        startPage = 1;
                        if (this._loadingPrevRequired) {
                            // loading previous was required before, but is no more
                            this._loadingPrevRequired = false;
                        }
                    }
                    for (let num = this._firstRenderedPage - 1; num >= startPage; num--) {
                        this._requestCounter++; // adjust request counter
                        this._pdfToView.getPage(num).then(this._renderPrevPage);
                    }
                    if (this._requestCounter == 0) {
                        // nothing to render, stop rendering
                        this._renderingRunning = false;
                    }
                };
                this._renderPrevPage = (page) => {
                    this._log.info("PdfJsViewer._renderPrevPage()");
                    // TODO: look at ways to use actual scrollbar width instead of guessed 17px (seems only possible after the whole rendering has been done)
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("renderPrevPage - using offset width: " + this._scroller.offsetWidth);
                    }
                    let viewport = page.getViewport((this._scroller.offsetWidth - WPTNamespace.SCROLLBAR_WIDTH) / page.getViewport(this._scale).width); // calculate viewport
                    let canvas = document.createElement('canvas');
                    let ctx = canvas.getContext('2d');
                    let renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    canvas.style.height = (viewport.height * this._scale) + "px";
                    canvas.style.width = (viewport.width * this._scale) + "px";
                    canvas.id = "page-" + page.pageNumber;
                    let pdf = this;
                    page.render(renderContext).then(function () {
                        pdf._requestCounter--; // adjust request counter
                        let pageNumber = page.pageNumber;
                        page.cleanup(); // free memory/resources
                        pdf._prependPage(pageNumber, canvas);
                    });
                };
                this._prependPage = (num, canvas) => {
                    this._log.info("PdfJsViewer._prependPage()");
                    this._pages.push({ pagenumber: num, element: canvas }); // add canvas to pages array
                    if (this._requestCounter == 0) {
                        // all rendering requests have returned, do the real work now
                        this._pages.sort(function (a, b) { return b.pagenumber - a.pagenumber; }); // sort pages descending by page numbers
                        let pageLength = this._pages.length;
                        for (let i = 0; i < pageLength; i++) {
                            if (this._holder.childNodes.length >= 5 * this._blockSize) {
                                // already "all" pages there, remove pages already "read" (or scrolled through)
                                this._lastRenderedPage--; // adjust last page
                                this._holder.removeChild(this._holder.lastChild); // remove last canvas
                                if (!this._loadingNextRequired) {
                                    // loading next was not required before, but is now
                                    this._loadingNextRequired = true;
                                }
                            }
                            let page = this._pages.shift(); // get page and remove from array
                            this._holder.insertBefore(page.element, this._holder.firstChild); // insert canvas as first child
                            this._firstRenderedPage--; // adjust first page
                        }
                        this._firstBlock -= this._blockSize; // adjust first block
                        this._lastBlock -= this._blockSize; // adjust last block
                        // adjust scrolling
                        let currentCanvas = this._holder.querySelector('#page-' + this._currentPage); // get canvas of current page
                        let pageHeight = this._holder.scrollHeight / this._renderedPages; // calculate page height
                        let pageOffsetTop = currentCanvas.offsetTop - this._defaultOffset; // calculate corrected offsetTop of current page
                        let calcScrollTop = pageOffsetTop + pageHeight - 10; // calculate end of current page (with a little buffer)
                        this._scroller.scrollTop = calcScrollTop; // scroll to end of current page (again), after swapping
                        this._renderingRunning = false; // nore more rendering running now
                        this._updatePageProgressBar(); // adjust progress bar
                    }
                };
                this._log.info("PdfJsViewer::constructor");
                this._scroller = this._holder.parentElement;
                this._firstRenderingDone = false;
                this._reRenderingRunning = false;
                this._reRenderAgain = false;
            }
        }
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
